import { RemixBrowser } from '@remix-run/react'

import { CacheProvider } from '@emotion/react'
import createEmotionCache from './create-emotion-cache'
import ClientStyleContext from './client-style-context'

import { hydrateRoot } from 'react-dom/client'

import React, { startTransition, StrictMode } from 'react'

interface ClientCacheProviderProps {
	children: React.ReactNode
}

function ClientCacheProvider({ children }: ClientCacheProviderProps) {
	let [cache, setCache] = React.useState(createEmotionCache())

	function reset() {
		setCache(createEmotionCache())
	}

	return (
		<ClientStyleContext.Provider value={{ reset }}>
			<CacheProvider value={cache}>{children}</CacheProvider>
		</ClientStyleContext.Provider>
	)
}

const hydrate = () => {
	startTransition(() => {
		hydrateRoot(
			document,
			<StrictMode>
				<ClientCacheProvider>
					<RemixBrowser />
				</ClientCacheProvider>
			</StrictMode>,
		)
	})
}

if (window.requestIdleCallback) {
	window.requestIdleCallback(hydrate)
} else {
	// Safari doesn't support requestIdleCallback
	// https://caniuse.com/requestidlecallback
	window.setTimeout(hydrate, 1)
}
